import React from "react"
import "./../index.css"
import { motion } from "framer-motion"

const boxVariants = {
  hover: {
    scale: 1.06,
    transition: {
      type: "spring",
    },
  },
}

const Portfolio = () => {
  return (
    <section
      data-aos="fade-up"
      className="portfolio-container"
      name="portfolio"
      id="portfolio"
    >
      <h1 className="heading">Projects I have Built</h1>
      <div className="projects-container">
        {/* Project 1 - Corona Tracker */}
        <motion.div
          className="projects"
          variants={boxVariants}
          whileHover="hover"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://hasansattar2.surge.sh"
          >
            <div className="project-images" id="coronaTracker"></div>
          </a>

          <div className="project-links">
            <div className="text">
              <h3>Expence Tracker</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://github.com/Hasansattar/EXPENSE_TRACKER_APP"
              >
                <i className="fab fa-github" title="github repo" id="github">
                  {" "}
                </i>
              </a>
              <a
                rel="noopener noreferrer"
                href="http://hasansattar2.surge.sh"
                target="_blank"
              >
                {" "}
                <i class="fas fa-laptop" 
                 title="live preview"
                 id="live"></i>
                 
              </a>
            </div>
          </div>
        </motion.div>

        {/* Project 2 - Shoe Store */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://covid19_virus.surge.sh"
          >
            <div className="project-images" id="shoeStore"></div>
          </a>

          <div className="project-links">
            <div className="text">
              <h3>Covid-19 Tracker</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://github.com/Hasansattar/covid19"
              >
                <i className="fab fa-github" title="github repo" id="github">
                  {" "}
                </i>
              </a>
              <a
                rel="noopener noreferrer"
                href="http://covid19_virus.surge.sh"
                target="_blank"
              >
                {" "}
                <i class="fas fa-laptop" 
                 title="live preview"
                 id="live"></i>
              </a>
            </div>
          </div>
        </motion.div>

        {/* Project 3 - Quiz App */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://react_shoes_store.surge.sh"
          >
            <div className="project-images" id="quizApp"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Shoe Store Application</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://github.com/Hasansattar/REACT_SHOES_STORE"
              >
                <i className="fab fa-github" title="github repo" id="github">
                  {" "}
                </i>
              </a>
              <a
                rel="noopener noreferrer"
                href="http://react_shoes_store.surge.sh"
                target="_blank"
              >
                {" "}
                <i class="fas fa-laptop" 
                 title="live preview"
                 id="live"></i>
              </a>
            </div>
          </div>
        </motion.div>

        {/* Project 4 - Explore matiari */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://animated-website-project4b.surge.sh"
          >
            <div className="project-images" id="matiari"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Aminated Website</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://github.com/Hasansattar/website_animated"
              >
                <i className="fab fa-github" title="github repo" id="github">
                  {" "}
                </i>
              </a>
              <a
                rel="noopener noreferrer"
                href="http://animated-website-project4b.surge.sh"
                target="_blank"
              >
                {" "}
                <i class="fas fa-laptop" 
                 title="live preview"
                 id="live"></i>
              </a>
            </div>
          </div>
        </motion.div>

        {/* Project 5 - Expense Tracker */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://silly-haibt-b5ca26.netlify.app/"
          >
            <div className="project-images" id="expenseTracker"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Virtual Lolly</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://github.com/Hasansattar/virtual_lolly_app_using_netlify_gatsby_faunadb_formik"
              >
                <i className="fab fa-github" title="github repo" id="github">
                  {" "}
                </i>
              </a>
              <a
                rel="noopener noreferrer"
                href="https://silly-haibt-b5ca26.netlify.app/"
                target="_blank"
              >
                {" "}
                <i class="fas fa-laptop" 
                 title="live preview"
                 id="live"></i>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://github.com/Hasansattar/"
        className="button-link"
      >
        <button className="button">More Projects</button>
      </a>
    </section>
  )
}

export default Portfolio